module.exports = __webpack_public_path__ + "media/images/regional-image12-aa4306b1798de6c72a3afbfe0595e276.jpg";